// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimesheetReportView1stheading{
    font-family: "Inter";
font-size: 18px;
font-weight: 700;
line-height: 21.78px;
letter-spacing: 0.02em;
text-align: left;
color:#0070E9;
}

.theadtablecellTimesummary{
    font-family: "Inter" !important;
font-size: 14px !important;
font-weight: 700 !important;
line-height: 16.94px !important;
letter-spacing: 0.02em !important;
color: #0070E9 !important;
white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;






    
}



.TableCellReportView{
    font-family: "Inter";
    font-size: 15px !important;
    font-weight: 400 !important;
    line-height: 10px !important;
    max-width:200px !important;
    letter-spacing: 0.02em !important;
    text-align: center;
    color:#375370 !important;
    height: 40px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}


@media only screen and (max-width: 1400px) {
  .timesheetSummarymediaquery {
    width: 78vw !important;
    justify-content: center;
    text-align: center;
    padding: 0.5vw;
  }
}

@media only screen and (min-width: 1400px) {
  .timesheetSummarymediaquery {
  width: 84vw !important;
  justify-content: center;
  text-align: center;
  padding: 0.5vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/panel/reports/TimesheetSummaryReports/TimesheetSummaryReportView.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB,aAAa;AACb;;AAEA;IACI,+BAA+B;AACnC,0BAA0B;AAC1B,2BAA2B;AAC3B,+BAA+B;AAC/B,iCAAiC;AACjC,yBAAyB;AACzB,8BAA8B;EAC5B,2BAA2B;EAC3B,kCAAkC;;;;;;;;AAQpC;;;;AAIA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;IAC1B,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;IACvB,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;EAChC,2BAA2B;EAC3B,kCAAkC;AACpC;;;AAGA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;EAChB;AACF;;AAEA;EACE;EACA,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd;AACF","sourcesContent":[".TimesheetReportView1stheading{\n    font-family: \"Inter\";\nfont-size: 18px;\nfont-weight: 700;\nline-height: 21.78px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#0070E9;\n}\n\n.theadtablecellTimesummary{\n    font-family: \"Inter\" !important;\nfont-size: 14px !important;\nfont-weight: 700 !important;\nline-height: 16.94px !important;\nletter-spacing: 0.02em !important;\ncolor: #0070E9 !important;\nwhite-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n\n\n\n\n\n\n    \n}\n\n\n\n.TableCellReportView{\n    font-family: \"Inter\";\n    font-size: 15px !important;\n    font-weight: 400 !important;\n    line-height: 10px !important;\n    max-width:200px !important;\n    letter-spacing: 0.02em !important;\n    text-align: center;\n    color:#375370 !important;\n    height: 40px !important;\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n    white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n\n@media only screen and (max-width: 1400px) {\n  .timesheetSummarymediaquery {\n    width: 78vw !important;\n    justify-content: center;\n    text-align: center;\n    padding: 0.5vw;\n  }\n}\n\n@media only screen and (min-width: 1400px) {\n  .timesheetSummarymediaquery {\n  width: 84vw !important;\n  justify-content: center;\n  text-align: center;\n  padding: 0.5vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
